import React, { useCallback, useState } from "react";

export type UIContextValue = {
  getUIState: (id: string) => any;
  setUIState: (id: string, value: any) => void;
};

export const UIContext = React.createContext<UIContextValue>({
  getUIState: (id: string) => null,
  setUIState: (id: string, value: any) => {},
});

export function useUIStateFromContext<T>(
  context: UIContextValue,
  key: string,
  initialValue: T,
): [T, (value: T) => void] {
  const currentValue = context.getUIState(key) ?? initialValue;
  const [stateValue, setStateValue] = useState<T>(currentValue);
  const setCurrentValue = useCallback(
    (value: T) => {
      setStateValue(value);
      context.setUIState(key, value);
    },
    [context, key, setStateValue],
  );

  return [stateValue as T, setCurrentValue];
}
